import type { FC } from 'react';
import LossAndDamageFilters from '../../screens/Claims/LossAndDamage/Filters/LossAndDamageFilters';
import LossAndDamageFooter from '../../screens/Claims/LossAndDamage/Footer/LossAndDamageFooter';
import LossAndDamageHeader from '../../screens/Claims/LossAndDamage/Header/LossAndDamageHeader';
import LossAndDamageList from '../../screens/Claims/LossAndDamage/List/LossAndDamageList';
import WithFilter from '../../screens/common/WithFilter';

const LossAndDamageClaimsPage: FC = () => {
  return (
    <WithFilter
      filterElement={<LossAndDamageFilters />}
      contentElement={<LossAndDamageList />}
      filterTitle="Search"
      pageTitle="Loss and Damage Claims"
      footerContent={<LossAndDamageFooter />}
      headerContent={<LossAndDamageHeader />}
    />
  );
};

export default LossAndDamageClaimsPage;
